export const DEFAULT_INVENTORIZATION_REGISTER_ID = 'register-1';

export function createInventorizationRegisterId(index: number) {
  return `register-${index + 1}`;
}

export function createInventorizationRegisterLabel(index: number) {
  return `Register ${index + 1}`;
}

export function isDefaultInventorizationRegisterLabel(label: string, index: number) {
  return label === createInventorizationRegisterLabel(index);
}

export function findNextInventorizationRegisterPhotoRef(photos: Array<{ registerId?: string | null }>) {
  const usedRegisterIds = new Set(photos.map(photo => photo.registerId).filter(Boolean));

  for (let index = 0; ; index += 1) {
    const candidate = createInventorizationRegisterId(index);

    if (!usedRegisterIds.has(candidate)) {
      return candidate;
    }
  }
}
